
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { FormsModule } from '@angular/forms';
import {TrainerDashboardComponent} from "./trainerDashboard.component";
import {TranslateModule} from "@ngx-translate/core";
import {RouterModule} from "@angular/router";
import {MatButtonModule} from "@angular/material/button";

@NgModule({
    declarations: [
        TrainerDashboardComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        TranslateModule,
        RouterModule,
        MatButtonModule,
    ],
    providers: [],
    bootstrap: [
        TrainerDashboardComponent,
    ]
})
export class TrainerDashboardModule { }
